import { EMAIL, NAME, PAYOFF, PHONE, ROLE, SITE_URL } from "./contact";

const VCARD = [
    "BEGIN:VCARD",
    "VERSION:3.0",
    "N:Cesari;Mino;;;",
    `FN:${NAME}`,
    "ORG:MC — Mino Cesari",
    `TITLE:${ROLE}`,
    `TEL;TYPE=CELL,VOICE:${PHONE}`,
    `EMAIL;TYPE=INTERNET:${EMAIL}`,
    `URL:${SITE_URL}`,
    `NOTE:${PAYOFF}`,
    "END:VCARD",
].join("\r\n");

export const downloadVCard = () => {
    const blob = new Blob([VCARD], { type: "text/vcard;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "mino-cesari.vcf";
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
};
